<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Data Penerima</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Nama"
                  ref="nama"
                  autofocus
                  required
                  @keydown.enter="focusRefs('badan_usaha')"
                  v-model="formData.nama"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Badan Usaha"
                  ref="badan_usaha"
                  required
                  @keydown.enter="focusRefs('alamat')"
                  v-model="formData.badan_usaha"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-combobox
                  label="Alamat"
                  ref="alamat"
                  required
                  :items="address"
                  @keydown.enter="focusRefs('email')"
                  v-model="formData.alamat"
                ></v-combobox>

                <!-- <v-text-field
                  label="Alamat"
                  ref="alamat"
                  required
                  @keydown.enter="focusRefs('email')"
                  v-model="formData.alamat"
                ></v-text-field> -->
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Email"
                  ref="email"
                  required
                  @keydown.enter="focusRefs('telp')"
                  v-model="formData.email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Telp"
                  ref="telp"
                  required
                  @keydown.enter="focusRefs('ket')"
                  v-model="formData.telp"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="kota"
                  ref="kota"
                  disabled
                  required
                  @keydown.enter="focusRefs('ket')"
                  v-model="formData.kota"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Ket"
                  ref="ket"
                  required
                  @keydown.enter="updateData"
                  v-model="formData.ket"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading"
            tabindex="-1"
            @click="
              $emit('close-modal');
              resetFormData();
            "
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            :loading="loading"
            text
            @click="updateData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "CreateModal",
  props: ["openModal", "data", "ttb"],
  data() {
    return {
      formData: {
        nama: "",
        badan_usaha: "",
        alamat: "",
        telp: "",
        email: "",
        kota: "",
        ket: ""
      },
      address: [],
      loading: false,
      loadingAddress: false
    };
  },
  watch: {
    data(val) {
      if (val.nama) {
        this.formData.nama = val.nama;
      }

      if (val.badan_usaha) {
        this.formData.badan_usaha = val.badan_usaha;
      }

      if (val.alamat) {
        this.formData.alamat = val.alamat;
      }

      if (val.telp) {
        this.formData.telp = val.telp;
      }

      if (val.email) {
        this.formData.email = val.email;
      }

      if (val.kota) {
        this.formData.kota = val.kota;
      }

      if (val.ket) {
        this.formData.ket = val.ket;
      }

      this.fetchAlamat(val.id);
    }
  },
  methods: {
    async updateData() {
      this.loading = true;

      this.formData.ttb = this.ttb;

      await axios
        .put(`penerima/${this.data.id}`, this.formData)
        .then(res => {
          this.loading = false;
          this.$emit("update-data", res.data);

          this.resetFormData();
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async fetchAlamat(id) {
      this.loadingAddress = true;

      await axios
        .get(`ttb/alamat?id=${id}`)
        .then(res => {
          this.loadingAddress = false;

          this.address = res.data;
        })
        .catch(err => {
          this.loadingAddress = false;

          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData = {
        nama: "",
        badan_usaha: "",
        alamat: "",
        telp: "",
        email: "",
        kota: "",
        ket: ""
      };
    },
    focusRefs(id) {
      this.$refs[id].$refs.input.focus();
    }
  }
};
</script>
